<template>
  <div>
    <!-- <div class="section-description"></div> -->
    <div class="section-paragraph">
      <div
        v-for="(item, index) of list"
        :key="index"
        class="border-t-1 border-gray-200 pt-5 mt-5 item"
      >
        <div class="flex">
          <div class="flex flex-1 justify-between w-full">
            <div v-if="!isPreview" class="w-full">
              <quill-editor
                :value="item.title"
                :options="getQuillEditorOptions('section-paragraph')"
                @change="updateItem(index, $event, 'title')"
                @ready="onEditorReady($event)"
              ></quill-editor>
            </div>
            <div v-else v-html="item.title"></div>
            <div class="controls invisible mt-3" v-if="!isPreview">
              <span
                class="cursor-pointer text-grey-500"
                @click="deleteItem(index)"
                ><i class="fa fa-times font-sm"></i
              ></span>
            </div>
          </div>
          <div
            @click="clickAccordion(index)"
            class="
              h-6
              w-6
              ml-2
              mt-3
              bg-blue
              rounded-full
              flex
              items-center
              justify-center
              cursor-pointer
            "
          >
            <span :class="[item.isCollapsed ? 'hidden' : 'block']">
              <i class="fa fa-angle-up text-white"></i>
            </span>
            <span class="mt-1" :class="[item.isCollapsed ? 'block' : 'hidden']">
              <i class="fa fa-angle-down text-white"></i>
            </span>
          </div>
        </div>
        <div v-if="!isPreview" :class="[item.isCollapsed ? 'hidden' : 'block']">
          <quill-editor
            :value="item.description"
            :options="getQuillEditorOptions('section-paragraph')"
            @change="updateItem(index, $event, 'description')"
            @ready="onEditorReady($event)"
          ></quill-editor>
        </div>
        <div
          :class="[item.isCollapsed ? 'hidden' : 'block']"
          v-else
          v-html="item.description"
        ></div>
      </div>
      <div
        v-if="!isPreview"
        @click="addNewItem()"
        class="text-pink md:text-xl text-base font-semibold cursor-pointer mt-4"
      >
        + Add Item
      </div>
    </div>
  </div>
</template>
<script>
import { cloneDeep } from 'lodash';
import quillMixin from '../../../mixins/quill';

export default {
  name: 'Accordion',
  mixins: [quillMixin],
  props: {
    isPreview: {
      type: Boolean,
      default: true,
    },
    index: {},
    getThemeSettings: {},
    content: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      dummyContent: {
        title: '<h3>Title</h3>',
        description: '<p>Description</p>',
        isCollapsed: false,
      },
    };
  },
  computed: {
    list() {
      return this.content.items;
    },
  },
  components: {},
  methods: {
    clickAccordion(index) {
      this.content.items[index].isCollapsed =
        !this.content.items[index].isCollapsed;
    },
    addNewItem() {
      const items = cloneDeep(this.list);
      items.push(cloneDeep(this.dummyContent));

      this.$emit('updateSectionContent', { items });
    },
    updateItem(index, { html }, key) {
      const items = cloneDeep(this.list);

      items[index][key] = html;

      this.$emit('updateSectionContent', { items });
    },
    deleteItem(index) {
      const items = cloneDeep(this.list);
      items.splice(index, 1);

      this.$emit('updateSectionContent', { items });
    },
  },
};
</script>
<style lang="scss" scoped>
.item:hover .controls {
  visibility: visible;
}
.section-paragraph {
  .border-t-1 {
    border-top: 1px solid #e0e0e0;
    &:first-child {
      border-top: none;
      margin-top: 0;
      padding-top: 0;
    }
  }
}
</style>
